import classnames from 'classnames';
import React from 'react';

import UserAvatar from 'components/user-avatar';

import styles from './styles.module.less';

const RemainderAvatar = ({ remainder, avatarSize }) => {
  const textSize = remainder > 10 ? 'text:small' : 'text:medium';
  const containerSize = avatarSize * 8;

  return (
    <div className="relative">
      <span
        className={`flex items:center justify:center block bgc:orangeLight c:orangeDark weight:bold ${textSize}`}
        style={{
          width: containerSize,
          height: containerSize,
          borderRadius: '100%',
        }}
      >
        +{remainder}
      </span>
    </div>
  );
};

const FacePile = ({
  className,
  alignment = 'left',
  maxImages = 5,
  userData = [],
  avatarSize = 3,
  showRemainderAvatar = true,
}) => {
  const isRightAligned = alignment === 'right';
  const avatarsToShow = userData.length > maxImages ? maxImages - 1 : maxImages;

  const avatars = userData
    .slice(0, avatarsToShow)
    .map((userDataItem, i) => (
      <UserAvatar
        avatarSrc={userDataItem.avatarSrc}
        name={userDataItem.name}
        avatarSize={avatarSize}
        alt="User avatar"
        key={i}
      />
    ));

  let unRenderedLabel;
  const unRenderedAvatarCount = userData.length - avatars.length;

  if (unRenderedAvatarCount > 0) {
    if (showRemainderAvatar) {
      avatars.push(
        <RemainderAvatar
          remainder={unRenderedAvatarCount}
          avatarSize={avatarSize}
          key={avatars.length}
        />
      );
    } else {
      unRenderedLabel = (
        <div className="text:medium weight:medium c:grey6 ml:small mt:small">
          +{unRenderedAvatarCount}
        </div>
      );
    }
  }

  return (
    <span className={classnames(styles.facePile, 'flex flexDirection:row')}>
      <ul
        className={classnames(
          styles.facePile,
          {
            [styles.isRightAligned]: isRightAligned,
          },
          className
        )}
      >
        {avatars.filter(Boolean).map((avatar, index) => (
          <li key={index}>{avatar}</li>
        ))}
      </ul>
      {unRenderedLabel}
    </span>
  );
};

export default FacePile;
